var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"background-color":"#f3f3f3","opacity":0.8,"loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('PermissionMatrix',{on:{"role-permissions":_vm.updatePermissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }